/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
(function () {
    let tabs = document.querySelectorAll('[role="tab"]');
    let panels = document.querySelectorAll('[role="tabpanel"]');

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', clickEventListener);
        tab.addEventListener('keydown', keydownEventListener);
        tab.index = index;
    });

    // When a tab is clicked, activateTab is fired to activate it
    function clickEventListener(event) {
        let target = event.target;

        if (target.classList.contains('result-count') === true) {
            target = target.parentElement;
        }

        activateTab(target, false);
    }

    // Handle keydown on tabs
    function keydownEventListener(event) {
        switch (event.key) {
            case 'End':
                event.preventDefault();
                // Activate last tab
                activateTab(tabs[tabs.length - 1]);
                break;
            case 'Home':
                event.preventDefault();
                // Activate first tab
                activateTab(tabs[0]);
                break;

            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case 'ArrowUp':
            case 'ArrowDown':
                event.preventDefault();
                break;

            case 'ArrowLeft':
                switchTabOnArrowPress(event, -1);
                break;
            case 'ArrowRight':
                switchTabOnArrowPress(event, 1);
                break;
        }
    }

    // Either focus the next, previous, first, or last tab
    // depening on key pressed
    function switchTabOnArrowPress(event, direction) {
        tabs.forEach(tab => {
            tab.addEventListener('focus', focusEventHandler);
        })

        if (typeof event.target.index !== 'undefined') {
            if (typeof tabs[event.target.index + direction] !== 'undefined') {
                tabs[event.target.index + direction].focus();
            } else if (event.key === 'ArrowLeft') {
                focusLastTab();
            } else if (event.key === 'ArrowRight') {
                focusFirstTab();
            }
        }
    }

    // Activates any given tab panel
    function activateTab(tab, setFocus) {
        setFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs();

        // Remove tabindex attribute
        tab.removeAttribute('tabindex');

        // Set the tab as selected
        tab.setAttribute('aria-selected', 'true');

        // Get the value of aria-controls (which is an ID)
        let controls = tab.getAttribute('aria-controls');

        // Remove hidden class from tab panel to make it visible
        document.getElementById(controls).classList.remove('hidden');

        // Set focus when required
        if (setFocus === true) {
            tab.focus();
        }
    }

    // Deactivate all tabs and tab panels
    function deactivateTabs() {
        tabs.forEach(tab => {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
            tab.removeEventListener('focus', focusEventHandler);
        });

        panels.forEach(panel => {
            panel.classList.add('hidden');
        });
    }

    // Make a guess
    function focusFirstTab() {
        tabs[0].focus();
    }

    // Make a guess
    function focusLastTab() {
        tabs[tabs.length - 1].focus();
    }

    function focusEventHandler(event) {
        setTimeout(checkTabFocus, 0, event.target);
    }

    // Only activate tab on focus if it still has focus after the delay
    function checkTabFocus(target) {
        let activeTarget = document.activeElement;

        if (activeTarget.classList.contains('result-count') === true) {
            activeTarget = activeTarget.parentElement;
        }

        if (target === activeTarget) {
            activateTab(target, false);
        }
    }
}());
